import { AgendamentoProvider } from '$providers/agendamento';
import { TipoQueixaProvider } from '$providers/tipo-queixa';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';


@Component({
  selector: 'page-agendamento-form',
  templateUrl: 'agendamento-form.html',
})
export class AgendamentoFormPage {

  tiposQueixa: Array<any> = [];
  dias: Array<any> = [];
  horarios: Array<any> = [];

  validations = { descricao: { min: 20, max: 300 } };

  agendamento: any = {};
  diaSelecionado = "";
  horarioSelecionado: any = {};

  constructor(public navCtrl: NavController, private agendamentoProvider: AgendamentoProvider,
    private view: ViewProvider, private tipoQueixaProvider: TipoQueixaProvider) { }

  ionViewDidLoad() {
    this.dias = [];
    this.tipoQueixaProvider.get().subscribe(
      (dados) => this.tiposQueixa = dados,
      (err) => console.error(err),
      () => this.carregarDias()
    );
  }

  carregarDias() {
    this.agendamentoProvider.buscarDias().subscribe(
      (dados) => this.processarDias(dados.datasDisponiveis),
      (err) => console.error(err)
    );
  }

  processarDias(datas) {
    this.dias = [];

    let mesAtual = "";

    let dataTmp;
    datas.forEach(element => {
      dataTmp = { data: element };
      dataTmp.mes = element.substring(3, 5);
      dataTmp.inicioMes = dataTmp.mes != mesAtual;

      mesAtual = dataTmp.mes;

      this.dias.push(dataTmp);
    });
  }

  selecionar(data) {
    console.log(data);
    if (data != this.diaSelecionado) {
      this.horarioSelecionado = {};
    }

    this.diaSelecionado = data;
    //this.navCtrl.push(AgendamentoHorariosPage, {data:data});
    if (!data) {
      this.horarios = [];
      return
    }

    this.agendamentoProvider.buscarHorarios(data).subscribe(
      (data) => this.horarios = data.horarios,
      (err) => console.error(err)
    );
  }
  selecionarHorario(horario) {
    this.horarioSelecionado = horario;
  }

  validar() {
    let erros = "";

    if (!this.agendamento.tipoQueixaId)
      erros += "- <b>Categoria</b> não informada.<br />";

    if (!this.agendamento.informacaoEmpresa)
      erros += "- <b>Empresa Reclamada</b> não informada.<br />";

    if (!this.agendamento.descricao) {
      erros += '- <b>Motivo</b> não informado<BR/>';
    } else if (this.agendamento.descricao.trim().length < this.validations.descricao.min) {
      erros += `- <b>Motivo</b> deve conter no mínimo ${this.validations.descricao.min} caracteres.<BR/>`;
    } else if (this.agendamento.descricao.trim().length > this.validations.descricao.max) {
      erros += `- <b>Motivo</b> não deve ultrapassar ${this.validations.descricao.max} caracteres.<BR/>`;
    }

    if (!this.diaSelecionado)
      erros += "- Não foi selecionado nenhum <b>dia</b> para o atendimento.<br />";
    else if (!this.horarioSelecionado || !this.horarioSelecionado.id)
      erros += "- Não foi selecionado nenhum <b>horário</b> para o atendimento.<br />";

    if (erros) {
      this.view.showMessage(erros);
      return false;
    }

    return true;
  }

  submit() {

    if (!this.validar())
      return;

    this.agendamento.horarioId = this.horarioSelecionado.id;

    this.view.showConfirm("Confirmar agendamento para o dia: " + this.horarioSelecionado.label + "?", () => {
      this.agendamentoProvider.marcarAgendamento(this.agendamento).subscribe(
        (dados) => {
          this.view.showMessage(dados.mensagem);
          this.navCtrl.pop();
        },
        (err) => console.error(err)
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/agendamento/agendamento-form/agendamento-form.ts